import { HasId } from '../../helpers/crud/edit/HasId';
import { FilterResult } from '../../helpers/crud/repository.service';
import { Injectable } from '@angular/core';
import { Plugins } from '@capacitor/core';
const { Storage } = Plugins;

@Injectable({
	providedIn: 'root'
})
export class StorageService {
	constructor() {}

	async setItem(key: string, value: any) {
		await Storage.set({
			key: key,
			value: JSON.stringify(value)
		});
	}

	async addItemInFilteredResult<TItem extends HasId>(key: string, id: any, newItem: any) {
		const result = await this.getItem<FilterResult<TItem>>(key);
		const oldItem = result.items.find((i) => i.id == id);
		if (oldItem) {
			const index = result.items.indexOf(oldItem);
			result.items[index] = newItem;
		} else {
			result.items.push(newItem);
		}
		result.total = result.items.length;
		await this.setItem(key, result);
	}

	async deleteItemInFilteredResult<TItem extends HasId>(key: string, id: any) {
		const result = await this.getItem<FilterResult<TItem>>(key);
		const oldItem = result.items.find((i) => i.id == id);
		const index = result.items.indexOf(oldItem);
		result.items.splice(index, 1);
		result.total = result.items.length;
		await this.setItem(key, result);
	}

	async getItem<T>(key: string): Promise<T> {
		const item = await Storage.get({ key: key });
		return item ? JSON.parse(item.value) : item;
	}

	async removeItem(key: string) {
		await Storage.remove({ key: key });
	}

	async clear() {
		await Storage.clear();
	}

	async keys() {
		const keys = await Storage.keys();
		return keys.keys;
	}
}
